import { OptionCard } from './OptionCard'
import { OptionsGrid } from './styles/OptionCardStyles'
import { QuestionTitle } from './styles/SignUpFlowStyles'
import { PARTNER_EXPERIENCE_OPTIONS } from '../../constants/partnerSurveyOptions'

interface PartnerSurveyStepExperienceProps {
  value: string | null
  onChange: (value: string) => void
}

export function PartnerSurveyStepExperience({ value, onChange }: PartnerSurveyStepExperienceProps) {
  return (
    <div>
      <QuestionTitle>What's your experience with affiliate marketing?</QuestionTitle>
      <OptionsGrid>
        {PARTNER_EXPERIENCE_OPTIONS.map((option) => (
          <OptionCard
            key={option.value}
            label={option.label}
            isSelected={value === option.value}
            onClick={() => onChange(option.value)}
            isMultiSelect={false}
          />
        ))}
      </OptionsGrid>
    </div>
  )
}
